import {createStore} from 'vuex'


const option = {
    state: {
        //0没登陆，1登录
        LoginStatus: 0,
        //用户类型为4留在首页，其它跳转到管理员首页
        userType:'-1',
        //当前激活的导航位置下标
        activeMenu: 0,
        //首页二级导航选中的key值,3-0,3-1,3-2
        activeMenuItem: undefined,
        role_id:0,
        id:0,
        birthday:"",
        account:'',
        createTime:"",
        cost_flag:"",
        gangwei:"",
        idnumber:"",
        minzu:"",
        name:"",
        sex:"",
        xueli:"",
        xuelizhuanye:"",
        zhengzhi:"",
        zhicheng:"",
        zyz_flag:"",
        address:"",
        sp_flag: 1, // 已完成课程的为1
    },
    mutations: {
        setLoginStatus(state, val) {
            state.LoginStatus = val
        },
        setaccount(state, val) {
            state.account = val
        },
        setTime(state, val) {
            state.createTime = val
        },
        setbirthday(state, val) {
            state.birthday = val
        },
        setRoleId(state, val) {
            state.role_id = val
        },
        setcost_flag(state, val) {
            state.cost_flag = val
        },
        setgangwei(state, val) {
            state.gangwei = val
        },
        setidnumber(state, val) {
            state.idnumber = val
        },
        setminzu(state, val) {
            state.minzu = val
        },
        setname(state, val) {
            state.name = val
        },
        setxueli(state, val) {
            state.xueli = val
        },
        setxuexiaozhuanye(state, val) {
            state.xuexiaozhuanye = val
        },
        setzhengzhi(state, val) {
            state.zhengzhi = val
        },
        setzhicheng(state, val) {
            state.zhicheng = val
        },
        setzyz_flag(state, val) {
            state.zyz_flag = val
        },
        setsex(state, val) {
            state.sex = val
        },
        setaddress(state, val) {
            state.address = val
        },
        setSpFlag(state, val) {
            state.sp_flag = val;
        },

    },
    actions: {},
    modules: {

    }
}

export default createStore(option)
